module.exports = __webpack_public_path__ + "static-v-shop/1786461253957/img/cristal-ojo-izquierdo.658324f8.png";